import { Action } from '@ngrx/store';
import { IWebAuthData, IWebAuthSessionData } from '../shared/models';

export const WEB_AUTH_SAVE = '[WebAuth] Save';
export const WEB_AUTH_CLEAR = '[WebAuth] Clear';
export const WEB_AUTH_UPDATE_DATA = '[WebAuth] Update webauth data';
export const WEB_AUTH_UPDATE_SESSION_DATA = '[WebAuth] Update session data';

export class WebAuthSaveAction implements Action {
  public readonly type = WEB_AUTH_SAVE;

  constructor(public payload: { webAuthData: IWebAuthData }) {}
}

export class WebAuthRemoveAction implements Action {
  public readonly type = WEB_AUTH_CLEAR;
}

export class WebAuthUpdateDataAction implements Action {
  constructor(public payload: { data: Partial<IWebAuthData> }) {}

  public readonly type = WEB_AUTH_UPDATE_DATA;
}

export class WebAuthUpdateSessionDataAction implements Action {
  constructor(public payload: { data: IWebAuthSessionData }) {}

  public readonly type = WEB_AUTH_UPDATE_SESSION_DATA;
}

export type All = WebAuthSaveAction | WebAuthRemoveAction | WebAuthUpdateDataAction | WebAuthUpdateSessionDataAction;
